module.exports = __webpack_public_path__ + "img/adhd-150x150.854015f2.png";